import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { SystemDialogsProvider } from "./components/SystemDialogs";
import "./styles.css";

createRoot(document.getElementById("root")!).render(<StrictMode><SystemDialogsProvider><App /></SystemDialogsProvider></StrictMode>);
